import { Controller } from "@hotwired/stimulus";

// Swaps a history media thumbnail to an "unavailable" glyph when its image (or
// video poster) fails to load. Covers the cases the server can't predict at
// render time: media that was removed, garbage-collected past its retention,
// or whose (dev) tunnel URL went stale and now 404s. When the server KNOWS the
// retention has lapsed it renders a distinct "expired" state up front instead.
export default class extends Controller<HTMLElement> {
  static targets = ["media", "fallback"];

  declare readonly mediaTargets: HTMLElement[];
  declare readonly fallbackTarget: HTMLElement;
  declare readonly hasFallbackTarget: boolean;

  connect(): void {
    // An <img> can finish (and fail) before Stimulus connects — e.g. a cached
    // 404 or an instantly-unreachable host. Catch that already-broken state.
    this.mediaTargets.forEach((el) => {
      if (el instanceof HTMLImageElement && el.complete && el.naturalWidth === 0) {
        this.fail(el);
      }
    });
  }

  onError(event: Event): void {
    const el = event.target as HTMLElement | null;
    if (el) this.fail(el);
  }

  private fail(el: HTMLElement): void {
    el.classList.add("hidden");
    if (this.hasFallbackTarget) this.fallbackTarget.classList.remove("hidden");
  }
}
